import React from 'react';
import { Shield, Star, MapPin, Handshake, PenTool, Wrench } from 'lucide-react';
const CARDS = [{
  title: 'Local Residential Glass Experts',
  copy: 'Serving Southeast Michigan homeowners with window glass, door glass, showers, mirrors, screens and custom glass projects since 2000.',
  Icon: MapPin
}, {
  title: 'Free In-Home Estimates',
  copy: 'Get a no-obligation estimate and clear next steps before work begins.',
  Icon: Star
}, {
  title: 'Glass-Only Guidance',
  copy: 'Learn whether your project needs new glass, insulated glass replacement, seal repair or full window replacement.',
  Icon: Handshake
}, {
  title: 'No High-Pressure Sales',
  copy: 'The team helps you understand repair, replacement and glass-only options without pressure.',
  Icon: Shield
}, {
  title: 'Custom Fabrication',
  copy: 'Get glass measured, ordered, fabricated or prepared for your window, door, shower, mirror, table top or custom project.',
  Icon: PenTool
}, {
  title: 'Warranty-Backed Work',
  copy: 'Professional residential glass repair, replacement and installation backed by warranty protection.',
  Icon: Wrench
}];
export function WhyChooseUs() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 text-white" data-id="element-1338" data-mp="26z66zv62ditp">
      <div className="max-w-7xl mx-auto" data-id="element-1339" data-mp="2b07ytqxnisln">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1340" data-mp="2aywrjh4zz2ps">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-normal" data-id="element-1341" data-mp="1x0qgnuev2dl9">
            Why Homeowners Choose Kosin's Glass
          </h2>
        </div>
        <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1342" data-mp="1o0tmjd9pcmit">
          {CARDS.map(({
          title,
          copy,
          Icon
        }, idx) => <li key={idx} className="bg-navy-800 rounded-lg p-8 border border-navy-700 anim-on-scroll" data-id="element-1343" data-mp="1s3gerfaac9gj" data-mpi={idx}>
              <div className="w-12 h-12 rounded-full bg-navy-900 border border-navy-600 flex items-center justify-center mb-6" data-id="element-1344" data-mp="3id0732ohkfns">
                <Icon className="w-6 h-6 text-brandBlue-600" aria-hidden="true" data-id="element-1345" data-mp="z8ib8vqtymy8" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-white" data-id="element-1346" data-mp="u7kw6s14a90y">{title}</h3>
              <p className="text-slate-300 leading-relaxed" data-id="element-1347" data-mp="q83nlpqe8vrk">{copy}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}